import React from "react";
import { ConfigProvider, Divider, Tabs, Typography } from "antd";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import PaidConversationChart from "./PaidConversationChart";
import ApproximateChargesChart from "./ApproximateChargesChart";
import { useAspSelector } from "../../../../../../test/jest-redux-hooks";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const { Title: AntTitle, Text } = Typography;

const TabCharts = () => {
  const { currentAccount } = useAspSelector((state) => state.app);

  const items = [
    {
      key: "3",
      label: "Paid Messages Delivered",
      children: <PaidConversationChart />,
    },
    {
      key: "4",
      label: "Approximate Total Charges",
      children: <ApproximateChargesChart />,
    },
  ];

  return (
    <div className="w-full p-4 bg-white rounded-lg shadow-md">
      <div>
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                inkBarColor: "#05805d", // active bar color
                colorPrimary: "#05805d",
              },
            },
          }}
        >
          <Tabs
            items={
              currentAccount?.role === "Account User" &&
              currentAccount?.account_type === "Agency"
                ? [items[0]]  // ✅ still an array
                : items
            }
          />
        </ConfigProvider>
      </div>
    </div>
  );
};

export default TabCharts;
